import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AkButton from '@atlaskit/button/custom-theme-button';
import AkMoreIcon from '@atlaskit/icon/core/show-more-horizontal';

const i18n = defineMessages({
	more: {
		id: 'editor-ellipsis-dropdown.placeholder.ellipsis.more',
		description: 'The label of the More icon',
		defaultMessage: 'More',
	},
});

export const EllipsisPlaceholder = () => {
	const intl = useIntl();
	const label = intl.formatMessage(i18n.more);
	const moreIcon = <AkMoreIcon color="currentColor" spacing="spacious" label={label} />;
	return (
		<AkButton testId="ellipsis-placeholder" isDisabled iconBefore={moreIcon} appearance="subtle" />
	);
};
